import * as React from 'react'

import { useAuth } from '@app/state/authenticate/hooks'

import history from './history'

interface Props {
  unauthedRedirectTo: string
  children: React.ReactNode
}

export const RouteUnauthed = function ({
  unauthedRedirectTo,
  children,
}: Props) {
  const auth = useAuth()

  React.useEffect(() => {
    if (!auth.isAuthenticated) {
      history.push(unauthedRedirectTo)
    }
  }, [auth, unauthedRedirectTo])

  return <React.Fragment>{children}</React.Fragment>
}
